import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Box,
  Typography,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SnagDetailsModal = ({ open, onClose, snag }) => {
  if (!snag) return null;

  const imageUrl =
    snag.image_url ||
    "https://renohome.blob.core.windows.net/reno-cms/e56d3d53-e335-425f-990e-16e6b2bbee1b";

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "16px",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontSize: 28,
          fontFamily: "Inter Tight",
          padding: "2vh 2vw",
        }}
      >
        <h5
          style={{
            color: "#0D0D0E",
            fontFamily: "Inter Tight",
            fontWeight: 500,
            letterSpacing: ".5px",
          }}
        >
          {snag.category}
        </h5>
        <IconButton onClick={onClose} size="large">
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 4,
          p: 4,
        }}
      >
        {/* Image section */}
        <Box
          sx={{
            flex: 1,
            maxWidth: 400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={imageUrl}
            alt={snag.category}
            onClick={() => window.open(imageUrl, "_blank")}
            style={{
              width: "100%",
              maxWidth: 400,
              height: 400,
              borderRadius: 16,
              objectFit: "cover",
              cursor: "pointer", // Indicates it's clickable
            }}
          />
        </Box>

        {/* Details section */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* Room */}
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ fontWeight: 500, mb: 0.5, color: "#0D0D0E" }}
              >
                Room
              </Typography>
              <Box
                sx={{
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                  border: "1px solid rgba(18, 18, 21, 0.10)",
                  padding: "1.5vh 1vw",
                  fontWeight: 500,
                  fontSize: 14,
                  color: "#0D0D0E",
                  fontFamily: "Inter Tight",
                }}
              >
                {snag.room}
              </Box>
            </Box>

            {/* Category */}
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="subtitle2"
                color="text.secondary"
                sx={{ fontWeight: 500, mb: 0.5, color: "#0D0D0E" }}
              >
                Category
              </Typography>
              <Box
                sx={{
                  borderRadius: "12px",
                  backgroundColor: "#fff",
                  border: "1px solid rgba(18, 18, 21, 0.10)",
                  padding: "1.5vh 1vw",
                  fontWeight: 500,
                  fontSize: 14,
                  color: "#0D0D0E",
                  fontFamily: "Inter Tight",
                }}
              >
                {snag.category}
              </Box>
            </Box>
          </Box>

          {/* Description */}

          <Typography
            variant="subtitle2"
            color="text.secondary"
            sx={{ fontWeight: 500, mt: 2, mb: 0.5, color: "#0D0D0E" }}
          >
            Description
          </Typography>
          <Box
            sx={{
              borderRadius: "12px",
              backgroundColor: "#fff",
              border: "1px solid rgba(18, 18, 21, 0.10)",
              padding: "1.5vh 1vw",
              fontSize: 14,
              color: "#0D0D0E",
              height: 280,
              whiteSpace: "pre-line",
              fontFamily: "Inter Tight",
              lineHeight: "22px",
            }}
          >
            {snag.description}
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SnagDetailsModal;
